import script from "./MusicSheetNodeView.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicSheetNodeView.vue?vue&type=script&setup=true&lang=js"

import "./MusicSheetNodeView.vue?vue&type=style&index=0&id=79d5b95b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d5b95b"]])

export default __exports__